// extracted by mini-css-extract-plugin
module.exports = {"anbefalinger":"dhsg22eI9-anbefalinger","anbefalinger__liste":"dhsg38XNy-anbefalinger__liste","anbefalingerListe":"dhsg38XNy-anbefalinger__liste"};